import React, { useEffect, useState, useRef, useReducer } from 'react';
import { withRouter } from 'react-router-dom';
import SignContainer from '../../component/sign/signContainer.jsx';
import { ApiCore } from '../../api';
import utils from '../../utils/utils';
import { Picker, List, ActivityIndicator, Checkbox, Toast, ListView, PullToRefresh } from 'antd-mobile';
import styles from './laborService.module.scss';
import select_arrow_down from '../../static/images/select_arrow_down.png';
import labor_service_icon from '../../static/images/labor_service_icon.png';
import no_agreement from '../../static/images/no_agreement.png';
import right_arrow from '../../static/images/rightArrow.png';
import OSS from "ali-oss";
const api = new ApiCore();

const allStatus = [{
    label: '所有状态',
    value: null
}, {
    label: '已签署',
    value: 1
}, {
    label: '未签署',
    value: 0
}, {
    label: '已失效',
    value: 2
}]

function LaborService(props: any) {

    const [list, setList] = useState([]);
    //项目list
    const [projectList, setProjectList] = useState([]);
    //项目加载对应类型映射
    const [projectTypeMap, setProjectTypeMap] = useState({});
    //选择的项目
    const [selectProject, setSelectProject] = useState<any>([null]);
    //选择的项目名称
    const [selectProjectName, setSelectProjectName] = useState<any>('全部项目');
    //状态列表
    const [statusList, setStatusList] = useState<any>(allStatus);
    //选择的状态
    const [selectStatus, setSelectStatus] = useState<any>([null]);
    //选择的状态名称
    const [selectStatusName, setSelectStatusName] = useState<any>('所有状态');
    //设置加载状态
    const [loading, setLoading] = useState<any>(null);
    //批量签名集合
    const [checkedList, setCheckedList] = useState<any>([]);
    //是否开启批量签名
    const [isMultiSign, setIsMultiSign] = useState(false);
    //存储进入未签署状态前的筛选条件
    const [preStatus, setPreStatus] = useState<any>([]);
    //是否全选
    const [allChecked, setAllChecked] = useState<any>(false);
    //设置强制刷新
    const [ignored, forceUpdate] = useReducer(x => x + 1, 0);
    //签名控制
    const mSignRef = useRef<any>();
    //签名提交前图片
    const [preSignImgUrl, setPreSignImgUrl] = useState('');
    //签署状态
    const [signIngStatus, setSignIngStatus] = useState('begin');
    // 上拉加载与下拉刷新
    const [isPullToRefresh, setIsPullToRefresh] = useState<boolean>(false); // 下拉刷新状态
    const [isMore, setIsMore] = useState<boolean>(true); // 是否还有更多数据
    const [curPage, setCurPage] = useState<number>(1); // 当前加载的页数
    const [curPageSize, setCurPageSize] = useState<number>(10); // 分页条数
    const [total, setTotal] = useState<number>(10); // 总条数
    const [listReady, setListReady] = useState(false);
    const [listLoading, setListLoading] = useState(false);
    // 获取OSS访问令牌
    const [ossData, setOssData] = useState<any>({});

    useEffect(() => {
        document.title = '服务协议';
        getProjectList();
        getOssData();
        let _selectProject = sessionStorage.getItem('LaborSelectProject') || '';
        if (_selectProject) {
            setSelectProject([_selectProject]);
        }
        let __selectStatus = sessionStorage.getItem('LaborSelectStatus') || '';
        let _selectStatus: any = __selectStatus;
        if (__selectStatus) {
            _selectStatus = parseInt(_selectStatus)
            setSelectStatus([_selectStatus]);
            if (_selectStatus == 0) {
                setIsMultiSign(true);
            }
        }
        let _checkedList = sessionStorage.getItem('LaborCheckedList') || '';
        if (_checkedList) {
            let _cList = JSON.parse(_checkedList);
            setCheckedList(_cList);
        }
        let _selectMultiSign = sessionStorage.getItem('LaborIsMultiSign');
        if (_selectMultiSign && _selectMultiSign === '1') {
            setIsMultiSign(true);
        }
        let _selectSignStatus = sessionStorage.getItem('LaborSigningStatus');
        if (_selectSignStatus) {
            setSignIngStatus(_selectSignStatus);
        }
        let _laborPreSignImgUrl = sessionStorage.getItem('LaborPreSignImgUrl');
        if (_laborPreSignImgUrl) {
            setPreSignImgUrl(_laborPreSignImgUrl);
        }
        getLaborAgreement(_selectProject, _selectStatus, { init: true });
        return () => {
        }
    }, [])

    /**
     * 获取OSS访问令牌
     */
    const getOssData = () => {
        api.GetCaseSts().then((res: any) => {
            if (res.code == 0) {
                if (!res.data) {
                    return
                }
                setOssData(res.data)
            }
        })
    };

    /**
     * 提取上传类型
     * @param {*} json 
     * @returns 
     */
    const filterPathPre = (json: any, type?: any) => {
        let newJson = json;
        let data: any = [];
        data = newJson.pathPre.split(',')
        data.map((i: any) => {
            if (i.includes(type)) {
                newJson.pathPre = i;
            }
        })
        return newJson;
    }

    const dataURLtoFile = (dataURI: any, type: string) => {
        let binary = atob(dataURI.split(',')[1]);
        let array = [];
        for (let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], { type: type });
    }

    const getProjectList = () => {
        //获取用户的项目列表
        api.getProject().then(res => {
            if (res.code == '0' && res.data.length > 0) {
                let filterArr: any = [
                    {
                        label: '全部项目',
                        value: null
                    }
                ];
                const _projectMap = { null: '' };
                for (let item of res.data) {
                    _projectMap[item.code] = item;
                    filterArr.push(
                        {
                            label: item.name,
                            value: item.code
                        }
                    )
                }
                setProjectList(filterArr);
                setProjectTypeMap(_projectMap);
            }
        })
    }

    const getLaborAgreement = (projectCode = '', status: any, param = {
        init: false
    }) => {
        setLoading(true);
        setCurPage(1);
        api.GetLaborUserAgreementList({
            page: 1,
            pageSize: 10,
            projectCode: projectCode,
            status: status
        }).then((res: any) => {
            if (res.code == 0) {
                let _list = (res.data && res.data.rows) || [];
                setList(_list || []);
                if (res.data && res.data.total >= 0) {
                    setTotal(res.data.total);
                }
                // 初始化设置全选状态，如果之前有过选择的
                let _checkedList = sessionStorage.getItem('LaborCheckedList') || '';
                if (param.init && _checkedList) {
                    let _cList = JSON.parse(_checkedList);
                    if ((_list).length === _cList.length) {
                        setAllChecked(true);
                    }
                }
                setLoading(false);
            }
        })
    }

    //当选了项目
    const onProjectOk = (value: any) => {
        if (value[0] !== undefined) {
            sessionStorage.setItem('LaborSelectProject', value[0]);
        }
        setSelectProject(value);
        let projectCode = (value && value[0]) || '';
        let status = (selectStatus && selectStatus[0]) || '';
        getLaborAgreement(projectCode, status);
    }

    //当选了签署类型
    const onStatusOk = (value: any) => {
        if (value[0] !== undefined) {
            sessionStorage.setItem('LaborSelectStatus', value[0]);
        }
        setSelectStatus(value);
        let projectCode = (selectProject && selectProject[0]) || '';
        // @ts-ignore
        getLaborAgreement(projectCode, value[0]);
    }

    const itemClick = (item: any) => {
        let _preSignUrl = '';
        // 未签署状况预览签名
        let isChecked = checkedList.some((v: any) => item.code === v.code);
        if (isMultiSign && isChecked) {
            _preSignUrl += '&isPreSign=1';
        }
        _preSignUrl += `&needView=${item.viewFlag}`;
        props.history.push(`/doctor/laborAgreement?code=${item.code}${_preSignUrl}`);
    }

    const inCheckedList = (item: any) => {
        let _list = checkedList;
        let hasItem = false;
        hasItem = _list.some((val: any) => {
            if (val.code === item.code) {
                return true;
            }
            return false;
        })
        if (!hasItem) {
            _list.push(item);
            if (_list.length === list.length) {
                setAllChecked(true);
            }
            setCheckedList(_list);
            sessionStorage.setItem('LaborCheckedList', JSON.stringify(_list));
            forceUpdate();
        }
    }

    const unCheckedList = (item: any) => {
        let _list = checkedList;
        _list = _list.filter((val: any) => {
            if (item.code === val.code) {
                return false;
            }
            return true;
        });
        setCheckedList(_list);
        sessionStorage.setItem('LaborCheckedList', JSON.stringify(_list));
        if (_list.length !== list.length) {
            setAllChecked(false);
        }
        forceUpdate();
    }

    const toPreStatus = () => {
        if (signIngStatus === 'begin') {
            // 退出
            setSelectStatus(preStatus);
            // 更新所选状态
            if (preStatus) {
                sessionStorage.setItem('LaborSelectStatus', preStatus[0]);
            }
            sessionStorage.setItem('LaborSelectStatus', preStatus[0])
            sessionStorage.setItem('LaborIsMultiSign', '0')
            setIsMultiSign(false);
            let projectCode = (selectProject && selectProject[0]) || '';
            // @ts-ignore
            getLaborAgreement(projectCode, preStatus[0]);
        } else if (signIngStatus === 'end') {
            // // 返回清空之前的签名状态
            sessionStorage.removeItem('LaborPreSignImgUrl');
            setSignIngStatus('begin');
            sessionStorage.setItem('LaborSigningStatus', 'begin');
        }
    }

    // 签名
    const toSign = () => {
        if (checkedList && checkedList.length === 0) {
            Toast.info('请至少选择一个服务协议', 0.8);
        } else if (signIngStatus === 'begin') {
            // 签署
            drawToSign();
        } else if (signIngStatus === 'end') {
            const _signedBefore = mSignRef.current.getIsDrawed();
            if (!_signedBefore) {
                Toast.info('请签名后提交', 0.8);
                return;
            }
            const imgUrl = preSignImgUrl;
            let client = new OSS({ ...filterPathPre(ossData, 'image') });
            let blob = dataURLtoFile(imgUrl, 'image/jpeg')
            let file = new File([blob], (new Date()).getTime() + '.jpg')
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (e) => {
                const path = `${ossData.pathPre}register/agreement/sign/${(new Date()).getTime()}.jpg`;
                // oss上传
                client.put(
                    path,
                    file,
                ).then((res: any) => {
                    let url = (res && res.url) || '';
                    setPreSignImgUrl(url);
                    let imgHtml = `<img style="width: 100px; margin-bottom: -22px;" src="${url}" />`;
                    // 完成
                    // 批量生成签名
                    // let imgHtml = `<img style="width: 100px; margin-bottom: -22px;" src="${preSignImgUrl}" />`;
                    // 批量签名
                    let _codes = checkedList.map((val: any) => val.code);
                    api.toSignLaborUserBatchAgreement({
                        codes: _codes,
                        sign: imgHtml
                    }).then((res: any) => {
                        if (res.code == 0) {
                            Toast.success('签名成功');
                            // 完成后退出至于前一状态
                            setSignIngStatus('begin');
                            sessionStorage.setItem('LaborSigningStatus', 'begin');
                            setSelectStatus(preStatus);
                            if (preStatus[0] !== undefined) {
                                // 更新之前所选状态
                                sessionStorage.setItem('LaborSelectStatus', preStatus[0]);
                            }
                            // 清除勾选状态
                            sessionStorage.removeItem('LaborCheckedList');
                            setAllChecked(false);
                            setCheckedList([]);
                            // 清除绘制图片
                            sessionStorage.removeItem('LaborPreSignImgUrl');
                            setIsMultiSign(false);
                            let projectCode = (selectProject && selectProject[0]) || '';
                            // @ts-ignore
                            getLaborAgreement(projectCode, preStatus[0]);
                        } else {
                            Toast.fail(res.message || '签名失败');
                        }
                    });
                    // 批量阅读已签名的信息
                    api.toUserAgreementMultiRead({
                        codes: _codes
                    });
                })
                    .catch((err: any) => {
                        Toast.fail('生成签名图片失败，请重新签名！', 1);
                    })
            };
        }
    }

    // 签名
    const drawToSign = () => {
        mSignRef.current && mSignRef.current.toShowModal();
    }

    // 重新签名
    const reSign = () => {
        mSignRef.current && mSignRef.current.toShowModal({
            resign: true
        });
    }

    // 更新签名图片并且到下一步
    const updateSignUrl = (imgUrl: any) => {
        setPreSignImgUrl(imgUrl);
        sessionStorage.setItem('LaborPreSignImgUrl', imgUrl);
        setSignIngStatus('end');
        sessionStorage.setItem('LaborSigningStatus', 'end');
    }

    // 进入多项签名
    const toSignMulti = () => {
        // 保存之前的状态
        let __selectStatus = selectStatus[0] || null;
        setPreStatus([__selectStatus]);
        // 进入未签署状态
        setSelectStatus([0]);
        sessionStorage.setItem('LaborSelectStatus', '0');
        // 返回
        sessionStorage.setItem('LaborIsMultiSign', '1');
        setIsMultiSign(true);
        let projectCode = (selectProject && selectProject[0]) || '';
        // @ts-ignore
        getLaborAgreement(projectCode, 0);
    }

    // 下拉加载
    const onPullToRefresh = () => {
        setIsPullToRefresh(true);
        setIsMore(true);
        // 重置状态
        setListReady(false);
        setLoading(true);
        setCurPage(1);
        setListLoading(true);
        api.GetLaborUserAgreementList({
            projectCode: selectProject[0],
            status: selectStatus[0],
            page: 1,
            pageSize: 10
        }).then((res: any) => {
            if (res.code == 0) {
                let _list = (res.data && res.data.rows) || [];
                if (res.code == 0) {
                    setList(_list);
                    setTotal(res.data.total);
                }
                setLoading(false);
                setListReady(true);
                setIsPullToRefresh(false);
                setListLoading(false);
            }
        })
    }

    // 触底上拉刷新
    const onEndListAdded = () => {
        setListReady(false);
        setListLoading(true);
        let nowPage = curPage;
        // 超出分页总数据后不再加载
        if (nowPage * curPageSize > total) {
            setIsMore(false);
            setListLoading(false);
            return;
        }
        nowPage++;
        setCurPage(nowPage);
        api.GetLaborUserAgreementList({
            projectCode: selectProject[0],
            status: selectStatus[0],
            page: nowPage,
            pageSize: 10
        }).then((res: any) => {
            setTimeout(() => {
                setListLoading(false);
                if (res.code == 0) {
                    setList(list.concat(res.data && res.data.rows) || []);
                    setTotal(res.data.total);
                }
                setListReady(true);
                setIsPullToRefresh(false);
            }, 375);
        });
    }

    // 上拉触底
    const onEndReached = () => {
        if (isMore) {
            //加载数据
            onEndListAdded()
        }
    }

    const dataView = new ListView.DataSource({
        rowHasChanged: (row1: any, row2: any) => row1 !== row2,
    });

    const dataSource = dataView.cloneWithRows(list);

    const row = (val: any, index: any) => (
        <div className={`${styles.list_item} ${isMultiSign ? styles.multi_sign : ''}`} key={index} onClick={() => { itemClick(val) }}>
            <div className={styles.item_head}>
                <div className={styles.head_left}>
                    接收日期：<span>{val.createTime ? val.createTime.replace('T', ' ') : ''}</span>
                </div>
                <div className={`${styles.head_right}  ${(val.status == 1 || val.status == 2) ? styles.sign : styles.no_sign}`}>{val.status == 1 ? '已签署' : val.status == 0 ? '未签署' : '已失效'}</div>
            </div>
            <div className={styles.item_body}>
                {
                    isMultiSign &&
                    <Checkbox
                        className={styles.item_checkbox}
                        checked={checkedList.some((item: any) => item.code === val.code)}
                        onClick={(e) => { e.stopPropagation() }}
                        onChange={event => {
                            if (event.target.checked) {
                                inCheckedList(val);
                            } else {
                                unCheckedList(val);
                            }
                        }}
                    />
                }
                <img className={styles.service_icon} src={`${labor_service_icon}`} alt="" />
                <div className={`${styles.body_text} ${val.viewFlag ? styles.text_need_read : ''}`}>
                    {val.title}
                </div>
                <img className={styles.right_icon} src={right_arrow} alt="" />
            </div>
        </div>
    );

    return (
        <div className={styles.laborService_content}>
            <ActivityIndicator animating={loading} size={"small"} text={'正在加载数据'} toast />
            {
                !isMultiSign &&
                <div className={styles.head_select}>
                    <div>

                        <Picker data={projectList} title='选择项目' extra={selectProjectName} cols={1} onOk={onProjectOk} value={selectProject}>
                            <List.Item arrow="down"></List.Item>
                        </Picker>
                        {/* <span>全部项目</span> */}
                        {/* <img src={select_arrow_down} alt="全部项目" /> */}
                    </div>
                    <div>
                        <Picker data={statusList} title='所有状态' extra={selectStatusName} cols={1} onOk={onStatusOk} value={selectStatus}>
                            <List.Item arrow="down"></List.Item>
                        </Picker>
                        {/* <span>所有状态</span>
                        <img src={select_arrow_down} alt="所有状态" /> */}
                    </div>
                </div>
            }
            {
                loading === false &&
                <div className={styles.list_content}>
                    {
                        (list && list.length > 0) &&
                        <ListView
                            style={{ height: 'calc(100vh - 2.66667rem)' }}
                            className={styles.listview}
                            dataSource={dataSource}
                            renderRow={row}
                            initialListSize={2000}
                            onEndReached={onEndReached}
                            onEndReachedThreshold={6}
                            scrollRenderAheadDistance={500}
                            scrollEventThrottle={200}
                            useBodyScroll={false}
                            pullToRefresh={
                                <PullToRefresh
                                    damping={60}
                                    distanceToRefresh={25}
                                    indicator={{}}
                                    direction="down"
                                    refreshing={isPullToRefresh}
                                    getScrollContainer={() => undefined}
                                    onRefresh={() => {
                                        onPullToRefresh()
                                    }}
                                >
                                </PullToRefresh>
                            }
                            renderFooter={() => (
                                <div style={{ padding: '12.5px 0 12px 0', marginBottom: '0px', textAlign: 'center' }}>
                                    {listLoading ? '正在加载...' : '没有更多'}
                                </div>)}
                        />
                    }
                    {/* {
                        list && list.map((val: any, index) => {
                            return (
                            <div className={`${styles.list_item} ${isMultiSign ? styles.multi_sign : ''}`} key={index} onClick={() => { itemClick(val)} }>
                                <div className={styles.item_head}>
                                    <div className={styles.head_left}>
                                        接收日期：<span>{val.createTime ? val.createTime.replace('T', ' ') : ''}</span>
                                    </div>
                                    <div className={`${styles.head_right}  ${(val.status == 1 || val.status == 2) ? styles.sign : styles.no_sign}`}>{ val.status == 1 ? '已签署' : val.status == 0 ? '未签署' : '已失效'}</div>
                                </div>
                                <div className={styles.item_body}>
                                    {
                                        isMultiSign && 
                                        <Checkbox 
                                            className={styles.item_checkbox}
                                            checked={checkedList.some((item: any) => item.code === val.code)}
                                            onClick={(e) => { e.stopPropagation() }}
                                            onChange={event => {
                                                if (event.target.checked) {
                                                    inCheckedList(val);
                                                } else {
                                                    unCheckedList(val);
                                                }
                                            }}
                                        />
                                    }
                                    <img className={styles.service_icon} src={`${labor_service_icon}`} alt="" />
                                    <div className={`${styles.body_text} ${val.viewFlag ? styles.text_need_read : ''}`}>
                                        {val.title}
                                    </div>
                                    <img className={styles.right_icon} src={right_arrow} alt="" />
                                </div>
                            </div>)
                        })
                    } */}
                    {
                        (list && list.length === 0) &&
                        <div className={styles.list_no_item} >
                            <img src={no_agreement} alt="" />
                        </div>
                    }
                </div>
            }
            {
                isMultiSign &&
                <div className={styles.list_all_checked}>
                    <div className={styles.all_checked_left}>
                        <Checkbox
                            className={styles.all_checked_checkbox}
                            checked={allChecked}
                            onChange={event => {
                                setAllChecked(event.target.checked);
                                if (event.target.checked) {
                                    setCheckedList(list);
                                    sessionStorage.setItem('LaborCheckedList', JSON.stringify(list));
                                } else {
                                    setCheckedList([]);
                                    sessionStorage.setItem('LaborCheckedList', JSON.stringify([]));
                                }
                            }}
                        />
                        <span className={styles.all_checked_text}>全选</span>
                    </div>
                    <div className={styles.all_checked_middle} onClick={() => { toPreStatus(); }}>{signIngStatus === 'begin' ? '退出' : '返回'}</div>
                    <div className={styles.all_checked_right} onClick={() => { toSign(); }}>{signIngStatus === 'begin' ? '开始签署' : '完成'}</div>
                </div>
            }
            {
                !isMultiSign &&
                <div className={styles.labor_multi_sign} onClick={() => { toSignMulti() }}>批量签署服务协议</div>
            }
            <SignContainer ref={mSignRef} updateSignUrl={updateSignUrl} ></SignContainer>
        </div>
    )
}

export default withRouter(LaborService);